import { ApiError, NetworkError } from '@/lib/api/errors';

/**
 * Maps a failed sign-in to an i18n key. The server's message is never shown:
 * it is English, and the code is all the UI needs (TechSpec §8.4).
 */
export type LoginErrorKey =
  | 'auth:errors.invalidCredentials'
  | 'auth:errors.locked'
  | 'auth:errors.unavailable'
  | 'auth:errors.invalidRequest'
  | 'common:errors.network'
  | 'common:errors.generic';

export function loginErrorKey(error: unknown): LoginErrorKey {
  if (error instanceof NetworkError) return 'common:errors.network';
  if (!(error instanceof ApiError)) return 'common:errors.generic';
  switch (error.code) {
    case 'UNAUTHORIZED':
      return 'auth:errors.invalidCredentials';
    case 'RATE_LIMITED':
      return 'auth:errors.locked';
    case 'SERVICE_UNAVAILABLE':
      return 'auth:errors.unavailable';
    case 'VALIDATION':
      return 'auth:errors.invalidRequest';
    default:
      return 'common:errors.generic';
  }
}
